import React, { createContext, useContext, useState } from 'react';
import { IAuthContextType } from './IAuthContextType';



const AuthContext = createContext<IAuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: any) => {
  const [authToken, setAuthToken] = useState<string | null>(null);
  const [referenceKey, setReferenceKey] = useState<string | null>(null);

  const setRefKey = (refKey: string | null) => {
    setReferenceKey(refKey);
  };

  const login = (token: string) => {
    setAuthToken(token);
  };

  const logout = () => {
    setAuthToken(null);
  };

  return (
    <AuthContext.Provider value={{ authToken, login, logout, referenceKey, setRefKey }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): IAuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};